import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-alerta-navegador',
  templateUrl: './alerta-navegador.component.html',
  styleUrls: ['./alerta-navegador.component.scss'],
})
export class AlertaNavegadorComponent implements OnInit {

  iphone: boolean = false;
  android: boolean = false;
  constructor(private modalCtrl: ModalController) { }

  ngOnInit() {
    const ua = navigator.userAgent;
    this.iphone = (/iPad|iPhone|iPod/.test(ua));
    this.android = (/Android/i.test(ua));
  }

  close() {
    this.modalCtrl.dismiss();
  }

  openBrowser() {

    const url = window.location.href;

    if (url.includes('localhost') || url.includes('127.0.0.1')) {
      alert('Esse recurso só funciona com um domínio público.');
      return;
    }
    
    if (this.android) {

      const isHttp = url.startsWith('http://');
      const cleanUrl = url.replace(/^https?:\/\//, '');
      const scheme = isHttp ? 'http' : 'https';

      const intentUrl =
        `intent://${cleanUrl}#Intent;scheme=${scheme};package=com.android.chrome;end`;

      window.location.href = intentUrl;

      setTimeout(() => {
        window.open(url, '_blank');
      }, 1500);

      return;
    }

    window.open(url, '_blank');
  }
}
